export const BERECHNUNGSGRUNDLAGE_DREI_MONATS_DURCHSCHNITT = {
  moegliche_arbeitstage: 'moegliche_arbeitstage',
  anzahl_sv_tage: 'anzahl_sv_tage',
} as const;

export type BerechnungsgrundlageDreiMonatsdurchschnitt =
  keyof typeof BERECHNUNGSGRUNDLAGE_DREI_MONATS_DURCHSCHNITT;
